<script setup lang="ts">
const config = useRuntimeConfig();
const route = useRoute();
const url = useRequestURL();
const baseURL =
  (config.public as any).siteUrl || `${url.protocol}//${url.host}`;
const siteName = (config.public as any).siteName || "Selectalent";
const siteTagline = (config.public as any).siteTagline || "";
const defaultTitle = `${siteName}`;
const defaultDescription =
  "Cursos y formaciones actualizadas en tecnología y negocio. Programas online, presenciales e híbridos con enfoque práctico.";

const canonical = computed(() => `${baseURL}${route.fullPath}`);
const ogImage = computed(
  () => (config.public as any).defaultOgImage || "/og-default.jpg"
);

// Title template: pages can set just “Page Title” → becomes “Page Title · Selectalent”
useHead({
  title: defaultTitle,
  titleTemplate: (title?: string) =>
    title && title !== siteName ? `${title} · ${siteName}` : `${siteName}`,

  link: [
    { rel: "canonical", href: canonical.value },
    { rel: "icon", href: "/favicon.ico" },
  ],

  meta: [
    // Base description
    { name: "description", content: defaultDescription },

    // Open Graph
    { property: "og:site_name", content: siteName },
    { property: "og:type", content: "website" },
    { property: "og:url", content: canonical.value },
    { property: "og:title", content: siteName },
    { property: "og:description", content: defaultDescription },
    { property: "og:image", content: ogImage.value },

    // Twitter
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: siteName },
    { name: "twitter:description", content: defaultDescription },
    { name: "twitter:image", content: ogImage.value },

    // Robots
    { name: "robots", content: "index,follow" },
    { name: "theme-color", content: "#0D57F2" },
  ],
});

// Pages can still add their own per-page SEO via useSeoMeta/useHead.
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
